// Thin gold botanical / sparkle ornaments (very fine lines, per brand).
export function GoldLeaf({ className = "", style }) {
  return (
    <svg className={className} style={style} width="120" height="120" viewBox="0 0 120 120" fill="none" aria-hidden="true">
      <path d="M60 112C60 74 40 44 12 30" stroke="#C89B5A" strokeWidth="1" strokeLinecap="round" />
      <path d="M60 96c-6-14-16-22-30-26M60 80c-5-11-13-17-24-20M60 64c-4-9-11-14-19-16" stroke="#C89B5A" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M60 112C60 74 80 44 108 30" stroke="#C89B5A" strokeWidth="1" strokeLinecap="round" />
      <path d="M60 96c6-14 16-22 30-26M60 80c5-11 13-17 24-20M60 64c4-9 11-14 19-16" stroke="#C89B5A" strokeWidth="0.8" strokeLinecap="round" />
    </svg>
  );
}

export function Sparkle({ className = "", size = 22 }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 0c.6 6.4 5 10.8 12 12-7 1.2-11.4 5.6-12 12-.6-6.4-5-10.8-12-12C7 10.8 11.4 6.4 12 0z" fill="#C89B5A" fillOpacity="0.85" />
    </svg>
  );
}

export function Divider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
      <span className="h-px w-16 bg-gold/50" />
      <Sparkle size={16} />
      <span className="h-px w-16 bg-gold/50" />
    </div>
  );
}
